import React from 'react'
import styles from '../../HomeSection.styles'
import { VEC_ICON_NAME } from '../../../../components/icons/constants'
import Icons from '../../../../components/icons/Icons'
import { useState } from 'react'
import { getUrgentActionLabel, getUrgentIcon, getUrgentLink } from '../../helperfuncitons/HelperFunction'
import { useRef } from 'react'
import useTxNavigate from '../../../../../libs/txnavigate/TxNavigateHook'

export default function MiniCTACarousel({
    ctaArray= {}
}) {
    const [activeIndex, setActiveIndex] = useState(0)
    const containerSlide = useRef(null)
    const navigate = useTxNavigate();

    const handleNavigation = (destination) => {
        navigate(destination)    
    }

    const handleIndexChange = (indx) => {
        containerSlide.current.style.transform = `translateX(${-indx * 100}%)`
        setActiveIndex(indx)
    }
    return (
        <div style={styles.urgentMainContainer}>
            <span style={styles.urgentIssuesHeader} >Some urgent issues need attention</span>
            <div ref={containerSlide} style={styles.urgentIssueInnerContainer}>
                {
                    Object.keys(ctaArray).filter(key => ctaArray[key] > 0).map((key) =>
                        <div style={styles.width400}>
                            <div style={{...styles.miniCTA, ...styles.width400}}>
                                <Icons familyName={'vec'} iconName={getUrgentIcon(key)} />
                                <div style={styles.quickActionCTA} onClick={() => handleNavigation(getUrgentLink(key))}>
                                    <div style={styles.quickActionCTALabel}>{getUrgentActionLabel(key, {
                                        count: ctaArray[key]
                                    })}</div>
                                    <Icons familyName={'vec'} iconName={VEC_ICON_NAME.RIGHT_ARROW_OUTLINE} />
                                </div>
                            </div>
                        </div>
                    )
                }
            </div>
            <div style={styles.urgentIssuesBottomBars}>
                {Object.keys(ctaArray).filter(key => ctaArray[key] > 0).map((cta,indx) => 
                    <div  onClick={() => handleIndexChange(indx)} style={{...styles.urgentIssuesBottomButton, ...(activeIndex === indx ? styles.urgentIssuesActiveState : styles.urgentIssuesDeactiveState )}}></div>
                    )}
            </div>
        </div>
    )
}